import { saveAs } from "file-saver";
import { put, select } from "redux-saga/effects";

import { fileApiFetch } from "common/utilities";
import { trackSaga } from "common/utilities/trackSaga";
import { activateModal } from "domains/modal/actions";
import { fetchLegacyTopicBriefingFailure, fetchLegacyTopicBriefingSuccess } from "domains/topic/actions";
import type { FetchLegacyTopicBriefingAction } from "domains/topic/actionTypes";
import { getTmTopic } from "domains/transformationMap/selectors";

export function* fetchLegacyTopicBriefingSaga(action: FetchLegacyTopicBriefingAction) {
  try {
    const topicBriefing: Blob = yield fileApiFetch(`topic/${action.payload.id}/briefing`, {
      headers: { Accept: "application/pdf" },
    });
    saveAs(topicBriefing, `Dynamic briefing - ${action.payload.name}.pdf`);
    yield put(fetchLegacyTopicBriefingSuccess());

    const topic: ReturnType<typeof getTmTopic> = yield select(getTmTopic);
    if (topic !== undefined)
      yield trackSaga({
        entityId: topic.id,
        entityName: topic.name,
        entityType: "Topic",
        name: "Generate briefing",
        page: "Topic detail",
        subpage: "Briefing",
      });
  } catch {
    yield put(fetchLegacyTopicBriefingFailure({ logoutOnAuthError: true }));
    yield put(activateModal({ id: "BriefingError" }));
  }
}
